<template>
    <fa-layers :class="['fa-2x heart-circle-button', { saved: site.is_faved }, variant]" @click.stop.prevent="toggleSave">
        <fa-icon :icon="['fas', 'circle']" class="heart-circle-button-border" />
        <fa-icon :icon="['fas', 'circle']" transform="shrink-2" class="heart-circle-button-circle" />
        
        <fa-icon v-if="!isLoading" :icon="['far', 'heart']" transform="shrink-8" />
        <div v-else class="spinner-grow" role="status" style="width: 17px;height: 17px;vertical-align: text-top;color: white;margin-top: 2px;">
          <span class="sr-only">Loading...</span>
        </div>
    </fa-layers>
</template>

<script>
import SiteMixins from '@/mixins/SiteMixins';

export default {
    name: 'HeartCircleButton',
    mixins: [
        SiteMixins,
    ],
    props: {
        site: {
          type: Object,
          required: true,
        },
        variant: {
          type: String,
          required: false,
          default: 'light',
        },
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        toggleSave() {
            const afterSave = (siteData) => {
                if (!siteData.error) {
                    this.$emit('data-changed', siteData)
                } else {
                    if (siteData.error.response.status == 403) {
                        this.$router.push({ name: 'Login', query: { redirect: this.$route.fullPath, continue: 'true' } });
                    }
                }
                this.isLoading = false
            }
            this.isLoading = true;
            if (this.site.is_faved) {
                this.unfavLocation(this.site, afterSave)
            } else {
                this.favLocation(this.site, afterSave)
            }
        },
    }
};
</script>

<style lang="scss">
.heart-circle-button {
    cursor: pointer;
    
    .heart-circle-button-border {
        color: white;
    }
    .heart-circle-button-circle {
        color: $darkest-gray;
    }
    .fa-heart {
        color: white;
    }
    
    &:hover {
        .heart-circle-button-circle {
            color: $light-gray;
        }
        .fa-heart {
            color: $darkest-gray;
        }
    }
    
    &.light {
        .heart-circle-button-border {
            color: $darkest-gray;
        }
        .heart-circle-button-circle {
            color: white;
        }
        .fa-heart {
            color: $darkest-gray;
        }
        
        &:hover {
            .heart-circle-button-border {
                color: white;
            }
            .heart-circle-button-circle {
                color: $darkest-gray;
            }
            .fa-heart {
                color: white;
            }
        }
    }
    
    &.saved {
        .heart-circle-button-border {
            color: white;
        }
        .heart-circle-button-circle {
            color: $primary;
        }
        .fa-heart {
            color: white;
        }
    }
    
    &.saved:hover {
        .heart-circle-button-border {
            color: white;
        }
        .heart-circle-button-circle {
            color: $lighter-gray;
        }
        .fa-heart {
            color: white;
        }
    }
}
</style>


